// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__JKCe7","item":"List_item__MOc9_"};